var exports = {
  "PL": "elementWrapperContainer__HL-k9p",
  "BB": "elementLabel__rKZkcD",
  "X": "elementLabelWithDescription__nYEbKi",
  "H4": "elementDescription__EXuIw0",
  "fD": "validationMessage__mbNZQ_",
};

module.exports = exports;
